import React, { Component } from 'react';
import {firestore} from './../../firebase-config';
import Cabecalho from './../../componentes/Cabecalho';
import moment from 'moment';
import 'moment-timezone';
import { Redirect } from 'react-router-dom';
import { publicarBanner } from './../../services/BannerService';
import { baixarBanner } from '../../services/VeiculoService';
import Modal from 'react-modal';

Modal.setAppElement('#root');

class DashBanners extends Component {

    constructor (props){
        super(props);

        this.state = {
            banners: [],
            countBanners: 0,
            modalShow: false,
            checkedItems: new Map(),
            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
        }
        this.mounted = false;
        this.publicarInstagramStories = this.publicarInstagramStories.bind(this);
        this.publicarInstagramFeed    = this.publicarInstagramFeed.bind(this);
        this.publicarFacebookFeed     = this.publicarFacebookFeed.bind(this);
        this.onChangeValidarBanners   = this.onChangeValidarBanners.bind(this);
        this.validaBanner             = this.validaBanner.bind(this);
    }

    componentDidMount(){

        this.mounted = true;

        // firestore.settings({ timestampsInSnapshots: true });
        firestore.collection("dashboard").doc("veiculos").collection("banners").orderBy("created_at", "desc")
        .get()
        .then((querySnapshot) => {

            if(this.mounted) {
                this.setState({
                    banners: [],
                    countBanners: 0
                });
            }

            querySnapshot.forEach(veiculo_dash => {

                var doc_dash = veiculo_dash.data();
                doc_dash.id  = veiculo_dash.id;

                firestore.collection('revenda').doc(doc_dash.idRevenda).collection('integracoes').get()
                .then((snapIntegracaoRevenda) => {

                    var statusInstagram = false;
                    var statusFacebook  = false;
                    snapIntegracaoRevenda.forEach(integracao_revenda_dash => {
                        if(integracao_revenda_dash.id === "instagram" && integracao_revenda_dash.data().status === true){
                            statusInstagram = integracao_revenda_dash.data().status;
                        }
                        if(integracao_revenda_dash.id === "facebook" && integracao_revenda_dash.data().status === true){
                            statusFacebook = integracao_revenda_dash.data().status;
                        }
                    });

                    doc_dash.statusInstagram = statusInstagram;
                    doc_dash.statusFacebook  = statusFacebook;

                    firestore.collection("revenda").doc(doc_dash.idRevenda).collection("banners").doc(doc_dash.idBanner)
                    .get()
                    .then(banner_dash => {

                        if (banner_dash.exists) {
                            doc_dash.banner    = banner_dash.data();
                            doc_dash.banner.id = banner_dash.id;

                            let banners = this.state.banners;
                            banners.push(doc_dash);

                            if(this.mounted) {
                                this.setState({
                                    banners: banners,
                                    countBanners: banners.length
                                });
                            }

                        }else{
                            firestore.collection("dashboard").doc("veiculos").collection("banners").doc(doc_dash.id).delete();
                        }

                    }).catch(function(error) {
                        console.log(error);
                    });

                }).catch(function(error) {
                    console.log(error);
                });
                                 
            });

        });
        
    }

    componentWillUnmount(){
        this.mounted = false;
    }

    async publicarInstagramStories(idBanner){

        this.setState({modalShow: true});

        var banner = this.state.banners.find(o => o.idBanner === idBanner);
        var bannerPublicar = banner.banner;

        bannerPublicar.ig_stories = true;
        bannerPublicar.ig_feed    = false;

        const response = await publicarBanner(bannerPublicar, "instagram");
        if(response.status === "success"){
            alert("Banner publicado no stories do instagram.");
            this.setState({modalShow: false});
        }else{
            alert("Erro ao publicar banner no stories do instagram.");
            this.setState({modalShow: false});
        }
        
    }

    async publicarInstagramFeed(idBanner){

        this.setState({modalShow: true});

        const banner = this.state.banners.find(o => o.idBanner === idBanner);
        var bannerPublicar = banner.banner;

        bannerPublicar.ig_stories = false;
        bannerPublicar.ig_feed    = true;

        const response = await publicarBanner(bannerPublicar, "instagram");
        if(response.status === "success"){
            alert("Banner publicado no feed do instagram.");
            this.setState({modalShow: false});
        }else{
            alert("Erro ao publicar banner no feed do instagram.");
            this.setState({modalShow: false});
        }

    }

    async publicarFacebookFeed(idBanner){

        this.setState({modalShow: true});

        const banner = this.state.banners.find(o => o.idBanner === idBanner);
        var bannerPublicar = banner.banner;

        bannerPublicar.fb_feed = true;

        const response = await publicarBanner(bannerPublicar, "facebook");
        if(response.status === "success"){
            alert("Banner publicado no feed do facebook.");
            this.setState({modalShow: false});
        }else{
            alert("Erro ao publicar banner no feed do facebook.");
            this.setState({modalShow: false});
        }

    }

    baixarBanner = async (idBanner) => {

        this.setState({
            modalShow: true
        });

        var banner = this.state.banners.find(o => o.idBanner === idBanner);
        var bannerPublicar = banner.banner;

        await baixarBanner(bannerPublicar);

        this.setState({
            modalShow: false
        });

    }

    onChangeValidarBanners(event, idRevenda, idVeiculo, idVeiculoDashboard){
        const v = {
            "idRevenda": idRevenda,
            "idVeiculo": idVeiculo,
            "idVeiculoDashboard": idVeiculoDashboard,
        }
        const name = event.target.name;
        const isChecked = event.target.checked;
        this.setState((prevState) => { prevState.checkedItems.set(name, isChecked) });
    }

    validaBanner(idBannerDashboard){

        firestore.collection("dashboard").doc("veiculos").collection("banners").doc(idBannerDashboard).delete()
        .then(res => { 
            // alert("Banner validado com sucesso!");
            window.location.reload();
        })
        .catch(err => { 
            alert("Erro ao validar banner!");
            // window.location.reload();
        });

    }

    validarBanner(){

        if(window.confirm('Deseja validar os banners marcados?')){

            var items = [];

            this.state.banners.forEach((v) => {
                this.state.checkedItems.forEach((checked, item) => {
                    if(item === v.id && checked === true){
                        items.push(v);
                    }      
                });
            });

            const qtdList = items.length;

            for(let i=0;i<qtdList;i++){

                const lastIndex = qtdList - 1;
                const index = i;
                var v = items[index];
                var idBannerDashboard = v.id;

                firestore.collection("dashboard").doc("veiculos").collection("banners").doc(idBannerDashboard).delete()
                .then(res => { 
                    if(index === lastIndex){
                        alert("Banners validados com sucesso!");
                        window.location.reload();
                    }
                })
                .catch(err => { 
                    alert("Erro ao validar banner!");
                });

            }
        }            

    }

    render(){

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin'){
            return <Redirect to='/acesso-negado' />
        }

        return (
            <div>
                <Cabecalho />
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Banners</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    Lista de banners - { this.state.countBanners } banners
                                </div>
                                <div className="panel-body">
                                    <a onClick={() => this.validarBanner()} className="btn btn-success">Validar banners</a>
                                    <br/><br/>
                                    <table width="100%" className="table table-striped table-bordered table-hover" id="dtVeículos">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Revenda</th>
                                                <th>Imagem</th>
                                                <th>Texto</th>
                                                <th>Data</th>
                                                <th>Ações</th>
                                                <th>Instagram Stories</th>
                                                <th>Instagram Feed</th>
                                                <th>Facebook Feed</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Object.keys(this.state.banners)
                                                .map(key => {
                                                    return (
                                                        <tr key={key}>
                                                            <td><p className="checkbox-item" key={this.state.banners[key].id}><label className="checkbox-label"><input type="checkbox" name={this.state.banners[key].id} onChange={(e) => this.onChangeValidarBanners(e, this.state.banners[key].idRevenda, this.state.banners[key].idVeiculo, this.state.banners[key].id)} /></label></p></td>
                                                            <td>{ this.state.banners[key].logo_revenda !== undefined ? <img src={ this.state.banners[key].logo_revenda } style={{ maxWidth: '100px', maxHeight: '80px' }} ></img> : "" }</td>
                                                            <td>{ this.state.banners[key].imagem !== undefined && this.state.banners[key].imagem.length > 0 ? <img src={ this.state.banners[key].imagem } style={{ maxWidth: '100px', maxHeight: '80px' }} ></img> : "" }</td>
                                                            <td>{ this.state.banners[key].texto !== undefined ? this.state.banners[key].texto : "" }</td>
                                                            <td>{ this.state.banners[key].created_at !== undefined ? moment(this.state.banners[key].created_at.seconds * 1000).locale('pt-BR').format("DD/MM/YYYY HH:mm") : "" }</td>
                                                            <td><a onClick={() => this.validaBanner(this.state.banners[key].id)}>Validar</a> / <a onClick={() => this.baixarBanner(this.state.banners[key].banner.id)}>Baixar</a></td>
                                                            <td>
                                                                <table  className="table table-bordered">
                                                                    <thead><tr><th style={{ width: '40px' }}>Publicar</th><th style={{ width: '40px' }}>Status</th><th style={{ width: '40px' }}>Ações</th></tr></thead>
                                                                    <tbody><tr> 
                                                                        { 
                                                                            this.state.banners[key].banner.ig_stories !== undefined && this.state.banners[key].banner.ig_stories === true ?
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].banner.valida_stories !== undefined && this.state.banners[key].banner.valida_stories === true ? 
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].statusInstagram !== undefined && this.state.banners[key].statusInstagram === true && (this.state.banners[key].banner.valida_stories === undefined || this.state.banners[key].banner.valida_stories === false) ? 
                                                                                <td><a onClick={() => this.publicarInstagramStories(this.state.banners[key].banner.id)}>Publicar</a></td>
                                                                            : <td></td> 
                                                                        } 
                                                                    </tr></tbody>
                                                                </table>
                                                            </td>
                                                            <td>
                                                                <table  className="table table-bordered">
                                                                    <thead><tr><th style={{ width: '40px' }}>Publicar</th><th style={{ width: '40px' }}>Status</th><th style={{ width: '40px' }}>Ações</th></tr></thead>
                                                                    <tbody><tr> 
                                                                        { 
                                                                            this.state.banners[key].banner.ig_feed !== undefined && this.state.banners[key].banner.ig_feed === true ?
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].banner.valida_feed !== undefined && this.state.banners[key].banner.valida_feed === true ? 
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].statusInstagram !== undefined && this.state.banners[key].statusInstagram === true && (this.state.banners[key].banner.valida_feed === undefined || this.state.banners[key].banner.valida_feed === false) ? 
                                                                                <td><a onClick={() => this.publicarInstagramFeed(this.state.banners[key].banner.id)}>Publicar</a></td>
                                                                            : <td></td> 
                                                                        } 
                                                                    </tr></tbody>
                                                                </table> 
                                                            </td>
                                                            <td>
                                                                <table  className="table table-bordered">
                                                                    <thead><tr><th style={{ width: '40px' }}>Publicar</th><th style={{ width: '40px' }}>Status</th><th style={{ width: '40px' }}>Ações</th></tr></thead>
                                                                    <tbody><tr> 
                                                                        { 
                                                                            this.state.banners[key].banner.fb_feed !== undefined && this.state.banners[key].banner.fb_feed === true ?
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].banner.fb_valida_feed !== undefined && this.state.banners[key].banner.fb_valida_feed === true ? 
                                                                                <td><span className="glyphicon glyphicon-ok-circle" style={{ fontSize: '20px', color: 'green'}}></span></td> 
                                                                            : <td><span className="glyphicon glyphicon-record" style={{ fontSize: '20px', color: 'gray'}}></span></td> 
                                                                        } 
                                                                        { 
                                                                            this.state.banners[key].statusFacebook !== undefined && this.state.banners[key].statusFacebook === true && (this.state.banners[key].banner.fb_valida_feed === undefined || this.state.banners[key].banner.fb_valida_feed === false) ? 
                                                                                <td><a onClick={() => this.publicarFacebookFeed(this.state.banners[key].banner.id)}>Publicar</a></td>
                                                                            : <td></td> 
                                                                        } 
                                                                    </tr></tbody>
                                                                </table> 
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalShow} 
                    className="modal-class modal-class-aguarde"
                    overlayClassName="modal-overlay"
                    >
                    <div>Aguarde...</div>
                </Modal>
            </div>
            
        )
    }

}

export default DashBanners